<template>
    <v-checkbox
        v-model="modelValue"
        base-color="gray-400"
        class="custom-checkbox"
        color="primary"
        :false-icon="CheckboxIcon"
        hide-details
        :ripple="false"
        :true-icon="CheckedBoxIcon"
        :value="props.value"
        @change="emit('change', modelValue)">
        <template #label>
            <span class="tw-text-sm tw-font-medium tw-tracking-normal tw-text-dark">
                <slot></slot>
            </span>
        </template>
    </v-checkbox>
</template>

<script setup lang="ts">
    import CheckedBoxIcon from '@/components/icons/CheckedBox.vue';
    import CheckboxIcon from '@/components/icons/CheckboxIcon.vue';

    const props = defineProps<{
        value: string | number | boolean;
    }>();

    const modelValue = defineModel<string[] | number[]>();
    const emit = defineEmits(['change']);
</script>

<style lang="scss">
    .custom-checkbox {
        .v-label--clickable {
            flex-grow: 1;
        }
    }
</style>
